'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = require('@shopify/theme-cart/request');

var _themeCart = require('@shopify/theme-cart');

var _functional = require('../utils/functional');

var _module = require('./mixins/module');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartUpdate = function (_Module) {
  (0, _inherits3.default)(CartUpdate, _Module);

  function CartUpdate(el) {
    (0, _classCallCheck3.default)(this, CartUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartUpdate.__proto__ || (0, _getPrototypeOf2.default)(CartUpdate)).call(this, el));

    _this.els = {
      el: el,
      items: _this.getContextElements('.' + _this.className + '_Item')
    };

    _this.loadingClass = 'crt-Products_Update-loading';

    _this.init = _this.init.bind(_this);
    _this.initItems = _this.initItems.bind(_this);
    _this.rebuildItems = _this.rebuildItems.bind(_this);

    _this.init();
    return _this;
  }

  (0, _createClass3.default)(CartUpdate, [{
    key: 'init',
    value: function init() {
      this.initItems();
      this.setListeners();
    }
  }, {
    key: 'setListeners',
    value: function setListeners() {
      var _this2 = this;

      this.handleMinusClick = this.handleMinusClick.bind(this);
      this.handlePlusClick = this.handlePlusClick.bind(this);
      this.handleRemoveClick = this.handleRemoveClick.bind(this);

      this.items.forEach(function (item) {
        item.plus.addEventListener('click', _this2.handlePlusClick);
        item.minus.addEventListener('click', _this2.handleMinusClick);
        item.remove.addEventListener('click', _this2.handleRemoveClick);
      });

      document.addEventListener('itemsUpdated', this.rebuildItems);
      window.addEventListener('cart:updated', this.rebuildItems);
    }
  }, {
    key: 'initItems',
    value: function initItems() {
      var _this3 = this;

      var cartEl = (0, _functional.getElement)('[data-section-id="cart"]');

      // Check for any new items.
      this.els.items = (0, _functional.getElements)('.' + this.className + '_Item', { context: cartEl });

      this.items = this.els.items.map(function (el) {
        var itemContext = { context: el };

        return {
          remove: (0, _functional.getElement)('.' + _this3.className + '_Remove', itemContext),
          input: (0, _functional.getElement)('.' + _this3.className + '_Input', itemContext),
          plus: (0, _functional.getElement)('.js-QuantityAdjuster_Control-plus', itemContext),
          minus: (0, _functional.getElement)('.js-QuantityAdjuster_Control-minus', itemContext),
          key: el.dataset.key,
          parentKey: el.dataset.parentKey,
          childUid: el.dataset.childUid,
          el: el
        };
      });
    }
  }, {
    key: 'rebuildItems',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var updates, cartResponse, cartSection, cartEl, activeDrawer;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                updates = {};
                _context.next = 3;
                return (0, _request.cartUpdate)({
                  updates: updates,
                  sections: ['cart']
                });

              case 3:
                cartResponse = _context.sent;


                // Render the whole cart section if empty.
                cartSection = this.getInnerHtml(cartResponse.sections.cart, '[data-section-id="cart"]');
                cartEl = (0, _functional.getElement)('[data-section-id="cart"]');

                if (!(!cartEl || !cartSection)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:

                cartEl.innerHTML = cartSection;

                this.init();

                this.updateGrapheneHCRecs();

                if (document.body.classList.contains('template-cart')) {
                  document.body.classList.remove('util-SiteOverflowed');
                  document.body.classList.remove('drw-DrawerIsActive');

                  activeDrawer = document.querySelector('.drw-Drawers-active');

                  if (activeDrawer) activeDrawer.classList.remove('drw-Drawers-active');

                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function rebuildItems() {
        return _ref.apply(this, arguments);
      }

      return rebuildItems;
    }()
  }, {
    key: 'handlePlusClick',
    value: function handlePlusClick(e) {
      e.preventDefault();

      this.item = this.getItem(e.target);
      var quantity = parseInt(this.item.input.value, 10) + 1;

      this.updateItem(quantity);
    }
  }, {
    key: 'handleMinusClick',
    value: function handleMinusClick(e) {
      e.preventDefault();

      this.item = this.getItem(e.target);
      var quantity = parseInt(this.item.input.value, 10) - 1;

      this.updateItem(quantity);
    }
  }, {
    key: 'handleRemoveClick',
    value: function handleRemoveClick(e) {
      e.preventDefault();

      this.item = this.getItem(e.target);

      this.updateItem(0);

      this.updateGrapheneHCRecs();
    }
  }, {
    key: 'updateItem',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quantity) {
        var _this4 = this;

        var cart, lineItem, itemsToUpdate, updates, cartResponse, contextEl, cartSection, cartEl;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = this.item.key;

                _context2.next = 3;
                return (0, _themeCart.getState)();

              case 3:
                cart = _context2.sent;
                lineItem = cart.items.find(function (cartItem) {
                  return cartItem.key === _this4.item.key;
                });
                itemsToUpdate = cart.items.filter(function (linkedItem) {
                  return linkedItem.properties && '__Parent uid' in linkedItem.properties && linkedItem.properties['__Parent uid'] === _this4.item.childUid;
                });

                itemsToUpdate.push(lineItem);

                updates = Object.fromEntries(itemsToUpdate.map(function (itemToRemove) {
                  return [itemToRemove.variant_id, quantity];
                }));
                _context2.next = 10;
                return (0, _request.cartUpdate)({
                  updates: updates,
                  sections: ['cart']
                });

              case 10:
                cartResponse = _context2.sent;
                contextEl = (0, _functional.getElement)('[data-module="cart-update"]');


                itemsToUpdate.forEach(function (item) {
                  // The line item <li> element.
                  var lineItemEl = (0, _functional.getElement)('[data-key="' + item.key + '"]', {
                    context: contextEl
                  });

                  // The updated line item from the cart response.
                  var updatedItem = _this4.getInnerHtml(cartResponse.sections.cart, '[data-key="' + item.key + '"]');

                  // If removing, there will be no updated item.
                  if (updatedItem === false) {
                    if (lineItemEl) {
                      lineItemEl.remove();
                    }
                  } else {
                    lineItemEl.innerHTML = updatedItem;
                  }
                });

                _context2.next = 15;
                return (0, _themeCart.getState)();

              case 15:
                cart = _context2.sent;

                if (!(cart.items.length === 0)) {
                  _context2.next = 25;
                  break;
                }

                // Render the whole cart section if empty.
                cartSection = this.getInnerHtml(cartResponse.sections.cart, '[data-section-id="cart"]');
                cartEl = (0, _functional.getElement)('[data-section-id="cart"]');

                if (!(!cartEl || !cartSection)) {
                  _context2.next = 21;
                  break;
                }

                return _context2.abrupt('return');

              case 21:

                cartEl.innerHTML = cartSection;

                cartEl.classList.remove('crt-Cart-graphenebelow');
                _context2.next = 28;
                break;

              case 25:
                this.initItems();
                this.setListeners();
                this.updateCartTotal(cartResponse);

              case 28:

                this.loading = false;
                this.item = null;

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateItem(_x) {
        return _ref2.apply(this, arguments);
      }

      return updateItem;
    }()
  }, {
    key: 'updateCartTotal',
    value: function updateCartTotal(response) {
      var updatedTotal = this.getInnerHtml(response.sections.cart, '[data-section="cart-total"]');

      var cartTotal = (0, _functional.getElement)('[data-section="cart-total"]', {
        context: this.el
      });

      cartTotal.innerHTML = updatedTotal;
    }
  }, {
    key: 'updateGrapheneHCRecs',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var carouselIdcart, carouselCart, recsWrap, className, cart, lastID;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                carouselIdcart = 'cart_carousel';
                carouselCart = document.querySelector('.cart');
                recsWrap = document.querySelector('.crt-Recs');
                className = this.loadingClass;


                recsWrap.classList.add(this.loadingClass);

                _context3.next = 7;
                return (0, _themeCart.getState)();

              case 7:
                cart = _context3.sent;


                // Get the product most recently added to the cart.
                lastID = cart.items[cart.items.length - 1].product_id;


                window.$g.fetch({
                  page_context: {
                    currency_id: window.Shopify.country,
                    product_id: '' + lastID
                  },
                  elements: [{ id: carouselIdcart }],
                  success: function success(response) {
                    if (response.hasOwnProperty('elements') && response.elements[carouselIdcart].product_count > 0) {
                      carouselCart.innerHTML = response.elements[carouselIdcart].html;

                      recsWrap.classList.remove(className);
                    } else {
                      // Don't hide at the mo.
                      // carouselCart.closest('.sec-Section').style.display = 'none'
                    }
                  },
                  error: function error() {
                    // Hide the closest carousel parent in case of error
                    // if (carouselCart) {
                    //   carouselCart.closest('.sec-Section').style.display = 'none'
                    // }
                  }
                });

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateGrapheneHCRecs() {
        return _ref3.apply(this, arguments);
      }

      return updateGrapheneHCRecs;
    }()
  }, {
    key: 'getInnerHtml',
    value: function getInnerHtml(html) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';

      var dom = this.convertToDOM(html);
      var findEl = dom.querySelector(selector);

      if (!findEl) {
        return false;
      } else {
        return findEl.innerHTML;
      }
    }
  }, {
    key: 'convertToDOM',
    value: function convertToDOM(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }
  }, {
    key: 'getItem',
    value: function getItem(el) {
      return this.items.find(function (item) {
        return item.el.contains(el);
      });
    }
  }, {
    key: 'isPersonalisationItem',
    value: function isPersonalisationItem() {
      return this.item && this.item.properties && this.lineItem.properties.__Personalised && this.lineItem.properties.__Personalised === 'true';
    }
  }, {
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      var productsWrap = (0, _functional.getElement)('[data-module="cart-update"]');
      if (!productsWrap) return;

      if (val) {
        productsWrap.classList.add(this.loadingClass);
      } else {
        productsWrap.classList.remove(this.loadingClass);
      }
    }
  }]);
  return CartUpdate;
}(_module2.default);

exports.default = CartUpdate;